import React from 'react';
import styled from 'styled-components';

import { Centered } from './Layout';

type Size = 'large' | 'medium' | 'small' | number;

function getSize(size: Size) {
    if (size !== undefined && size !== null) {
        if (size === 'medium') {
            return '16px';
        } else if (size === 'small') {
            return '12px';
        } else if (size === 'large') {
            return '24px';
        } else {
            return `${size}px`;
        }
    }
    return '12px';
}

interface Props {
    size?: Size;
}

export const Spinner = ({ size = 'medium' }: Props) => (
    <StyledSpinner $size={getSize(size)}>
        <svg
            width="100%"
            height="100%"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
        >
            <circle
                cx="50"
                cy="50"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                r="40"
                strokeWidth="8"
                strokeDasharray="62.83185307179586 62.83185307179586"
                transform="rotate(323.656 50 50)"
            >
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    calcMode="linear"
                    values="0 50 50;360 50 50"
                    keyTimes="0;1"
                    dur="1s"
                    begin="0s"
                    repeatCount="indefinite"
                />
            </circle>
        </svg>
    </StyledSpinner>
);

export const SingleSpinner = ({ size = 'medium' }: Props) => (
    <StyledSpinner $size={getSize(size)}>
        <svg
            height="100%"
            width="100%"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
        >
            <circle cx="50" cy="50" fill="none" strokeLinecap="round" r="39" strokeWidth="12"></circle>
            <circle
                cx="50"
                cy="50"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                r="39"
                strokeWidth="12"
                strokeDasharray="65 300"
                transform="rotate(323.656 50 50)"
            >
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    calcMode="linear"
                    values="0 50 50;360 50 50"
                    keyTimes="0;1"
                    dur="1s"
                    begin="0s"
                    repeatCount="indefinite"
                />
            </circle>
        </svg>
    </StyledSpinner>
);

export const PageSpinner = () => (
    <SpinnerContainer>
        <Spinner size="large" />
    </SpinnerContainer>
);

const StyledSpinner = styled.div<{ $size: string }>`
    display: flex;
    position: relative;
    stroke: ${({ theme }) => theme.colors.cocoa100};
    width: ${({ $size }) => $size};
    height: ${({ $size }) => $size};
`;

const SpinnerContainer = styled(Centered)`
    width: 100%;
    height: 100%;
`;
